<template>
    <div class="container-fluid p-2">
        <!-- Top Cards Row -->
        <div class="row g-2">
            <div
                class="col-md-3"
                v-for="(card, index) in 4"
                :key="'card-' + index"
            >
                <div class="card card-skeleton">
                    <div class="card-body d-flex align-items-center py-2">
                        <div class="skeleton-circle mr-3"></div>
                        <div class="flex-grow-1">
                            <div class="skeleton-text w-75 mb-1"></div>
                            <div class="skeleton-text w-50"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Charts Row -->
        <div class="row g-2 mt-2">
            <div class="col-md-4">
                <div class="card card-skeleton">
                    <div class="card-body">
                        <div class="skeleton-text w-50 mb-3"></div>
                        <div class="skeleton-circle-chart mb-3"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card card-skeleton">
                    <div class="card-body">
                        <div class="skeleton-text w-50 mb-3"></div>
                        <div class="skeleton-circle-chart mb-3"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card card-skeleton">
                    <div class="card-body">
                        <div class="skeleton-text w-50 mb-3"></div>
                        <div class="skeleton-bar-list">
                            <div
                                class="skeleton-bar-item"
                                v-for="n in 4"
                                :key="n"
                            >
                                <div class="skeleton-text w-25 mb-1"></div>
                                <div class="skeleton-bar"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bottom Charts Row -->
        <div class="row g-2 mt-2">
            <div class="col-md-8">
                <div class="card card-skeleton">
                    <div class="card-body">
                        <div class="skeleton-text w-50 mb-3"></div>
                        <div class="skeleton-bar-chart"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card card-skeleton">
                    <div class="card-body">
                        <div class="skeleton-text w-50 mb-3"></div>
                        <div class="skeleton-color-blocks">
                            <div class="skeleton-block red"></div>
                            <div class="skeleton-block yellow"></div>
                            <div class="skeleton-block green"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>

/* General Skeleton Styles */
.skeleton-text {
    height: 0.875rem;
    background-color: #ebeef2;
    border-radius: 3px;
    animation: pulse 1.5s infinite;
}

.skeleton-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ebeef2;
    animation: pulse 1.5s infinite;
}

.skeleton-circle-chart {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    background-color: #ebeef2;
    margin: 0 auto;
    animation: pulse 1.5s infinite;
}

.skeleton-bar-chart {
    height: 250px;
    background-color: #ebeef2;
    border-radius: 3px;
    animation: pulse 1.5s infinite;
}

.skeleton-bar-list {
    padding: 0.5rem 0;
}

.skeleton-bar-item {
    margin-bottom: 0.75rem;
}

.skeleton-bar {
    height: 0.875rem;
    background-color: #ebeef2;
    border-radius: 3px;
    animation: pulse 1.5s infinite;
}

.skeleton-color-blocks {
    display: flex;
    justify-content: space-between;
    padding: 1rem 0;
}

.skeleton-block {
    width: 30%;
    height: 80px;
    border-radius: 3px;
}

.skeleton-block.red {
    background-color: rgba(255, 99, 132, 0.15);
}

.skeleton-block.yellow {
    background-color: rgba(255, 205, 86, 0.15);
}

.skeleton-block.green {
    background-color: rgba(75, 192, 192, 0.15);
}

/* Animación de pulso */
@keyframes pulse {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.6;
    }
    100% {
        opacity: 1;
    }
}

/* Ajustes de margen para las filas */
.row {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
}

/* Ajustes de padding para las columnas */
.col-md-3,
.col-md-4,
.col-md-8 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

/* Estilos para las tarjetas skeleton */
.card-skeleton {
    border: 1px solid #e4e7ea;
    border-radius: 0.25rem;
    box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.05);
    background-color: #f2f2f2;
    margin-bottom: 1rem;
}

/* Evitar que los estilos de skeleton afecten a otros componentes */
/* Asegúrate de que todas las clases utilizadas sean específicas y no conflictivas */

/* Opcional: Agregar un contenedor único para el skeleton loader */
.container-fluid.p-2 > .row > .card-skeleton {
    /* Si necesitas estilos adicionales específicos para estos skeletons */
}
</style>
